var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useTheme from './UseTheme';
export default function useStyleObject(props, themeAccessor) {
    var _a;
    var baseStylingSupports = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        baseStylingSupports[_i - 2] = arguments[_i];
    }
    var theme = useTheme();
    var activeThemeVariation = (_a = themeAccessor(theme)).getStyleObject.apply(_a, __spreadArray([props], __read(baseStylingSupports), false));
    return activeThemeVariation;
}
//# sourceMappingURL=UseStyleObject.js.map